import { useRef } from "react";

import Input from "./Input";

export type TextFieldProps = {
    id: string;
    label: string;
    type?: "text" | "password" | "date" | "time" | "datetime-local" | "number";
    value?: string;
    placeholder?: string;
    autoComplete?: string;
    disabled?: boolean;
    min?: number;
    step?: number;
    inputMode?: "numeric" | "decimal";
    list?: string;
    maxLength?: number;
    required?: boolean;
    className?: string;
    onChange?: (value: string) => void;
};

export default function TextField({ id, label, type = "text", value, placeholder, autoComplete, disabled, min, step, inputMode, list, maxLength, required, className = "mb-4", onChange }: TextFieldProps) {
    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
        <div className="flex flex-col">
            <label htmlFor={id} className="mb-1 text-[16px] font-bold text-slate-500">{label}</label>
            <Input
                ref={inputRef}
                type={type}
                id={id}
                placeholder={placeholder}
                autoComplete={autoComplete}
                value={value}
                disabled={disabled}
                min={min}
                step={step}
                inputMode={inputMode}
                list={list}
                maxLength={maxLength}
                required={required}
                onChange={(event) => onChange?.(event.target.value)}
                onClick={() => {
                    if (type !== "date") return;
                    inputRef.current?.showPicker?.();
                }}
                className={`${className} h-14 bg-slate-50 hover:ring-2 hover:ring-slate-100 focus:ring-2 focus:ring-[#1a6fbf] disabled:opacity-60`}
            />
        </div>
    );
}
